
  import * as sanityRuntime$HfeY_45bso3QXGird4RxF5wIp9gouAxtMNCp7IWwK1J60 from '/opt/build/repo/nuxt/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@8.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/sanity'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "sanity",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['sanity']: { provider: sanityRuntime$HfeY_45bso3QXGird4RxF5wIp9gouAxtMNCp7IWwK1J60, defaults: {"projectId":"im4aehvv","dataset":"production"} }
    }
  }
